import Icon from "@react-native-vector-icons/material-design-icons";
import theme from "assets/theme";
import moment from "moment";
import React, { createElement, useContext, useMemo, useState } from "react";
import { StyleSheet, Text, View } from "react-native";
import PressableContainer from "webComponentsFormElements/PressableContainer.component";
import { OrganizationContext } from "webContext/Organization.context";

const classes = StyleSheet.create({
  root: {
    alignItems: "center",
    flexDirection: "row",
    padding: 8,
  },
  labelContainer: {
    gap: 2,
  },
  requiredText: {
    color: theme.color.error,
  },
  editIcon: {
    marginLeft: 10,
  },
});

export default function CustomDateTimePicker(props) {
  const { title, onDateChange, required, value, minimumDate, endDate } = props;

  const [isShown, setIsShown] = useState(false);

  const { organizationColor } = useContext(OrganizationContext);

  const stateClasses = useMemo(
    () =>
      StyleSheet.create({
        label: {
          color: organizationColor,
          marginRight: 6,
          fontWeight: theme.font.weight.medium,
        },
        input: {
          display: "block",
          width: "100%",
          padding: 4,
          margin: 10,
          borderRadius: 6,
          borderColor: organizationColor,
          borderStyle: "solid",
          borderWidth: 2,
        },
      }),
    [organizationColor],
  );

  const onChangeHandler = (selectedDate) => {
    minimumDate && selectedDate < minimumDate
      ? onDateChange?.(minimumDate)
      : onDateChange?.(selectedDate);
  };

  return (
    <View style={classes.root}>
      <View style={classes.labelContainer}>
        <Text style={stateClasses.label}>
          {title}:{required && <Text style={classes.requiredText}> *</Text>}
        </Text>
        {value && (
          <Text style={{ color: theme.color.backgroundText }}>
            {moment(value).format("MMM DD, YYYY hh:mm A")}
          </Text>
        )}
      </View>

      {!isShown && (
        <PressableContainer
          onPress={() => {
            setIsShown((wasShown) => !wasShown);
            endDate && !isShown && onDateChange?.(null);
          }}
        >
          <Icon
            style={classes.editIcon}
            name="pencil-outline"
            size={30}
            color={organizationColor}
          />
        </PressableContainer>
      )}

      {isShown &&
        createElement("input", {
          type: "datetime-local",
          value: value ? moment(value).format("YYYY-MM-DDTHH:mm") : "",
          onChange: (event) => onChangeHandler(new Date(event.target.value)),
          onBlur: () => setIsShown(false),
          style: stateClasses.input,
        })}
    </View>
  );
}
